import { useEffect } from "react";

type QuinnPanelHotkeys = {
    open: () => void;
    close: () => void;
    startNewChat: () => void;
    isOpen: boolean;
    isOverlay: boolean;
};

export function useQuinnPanelHotkeys({
    open,
    close,
    startNewChat,
    isOpen,
    isOverlay,
}: QuinnPanelHotkeys) {
    useEffect(() => {
        function onKeyDown(event: KeyboardEvent) {
            const isMac = navigator.platform.toUpperCase().includes("MAC");
            const modifier = isMac ? event.metaKey : event.ctrlKey;

            if (modifier && event.shiftKey && event.key.toLowerCase() === "o") {
                event.preventDefault();
                startNewChat();
                open();
                return;
            }
            if (event.key === "Escape" && isOverlay && isOpen) {
                close();
            }
        }

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [close, isOpen, isOverlay, open, startNewChat]);
}
